
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 11.67C1 5.54 5.804 1 12 1s11 4.543 11 10.673-4.804 10.67-11 10.67c-1.114 0-2.18-.149-3.184-.424a.884.884 0 00-.589.044l-2.184.963a.88.88 0 01-1.234-.778l-.06-1.959a.87.87 0 00-.295-.627C2.314 17.648 1 14.877 1 11.67zm7.626-2.005l-3.231 5.126c-.311.492.294 1.045.756.693l3.47-2.634a.66.66 0 01.795-.003l2.571 1.928a1.648 1.648 0 002.387-.44l3.234-5.124c.308-.492-.297-1.047-.759-.695l-3.47 2.634a.66.66 0 01-.795.003l-2.571-1.928a1.65 1.65 0 00-2.387.44z","fill":"url(#paint0_radial_6993_421)"}}),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_radial_6993_421","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"matrix(24.2 0 0 24.2 4.685 23)"}},[_c('stop',{attrs:{"stop-color":"#09F"}}),_c('stop',{attrs:{"offset":".6","stop-color":"#A033FF"}}),_c('stop',{attrs:{"offset":".9","stop-color":"#FF5280"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF7061"}})])])])
          )
        }
      }
    